import moment from 'moment';

export interface YearValidationResult {
  isValid: boolean;
  year: number | null;
  momentDate: moment.Moment | null;
}

export const YEAR_VALIDATION_CONFIG = {
  MIN_YEAR: 1700,
  MAX_YEAR: 2100,
  INPUT_MAX_LENGTH: 4,
};

export function validateYearInput(
  value: string,
  minYear: number = YEAR_VALIDATION_CONFIG.MIN_YEAR,
  maxYear: number = YEAR_VALIDATION_CONFIG.MAX_YEAR
): YearValidationResult {
  const trimmedValue = (value || '').trim();
  if (trimmedValue === '') {
    return { isValid: false, year: null, momentDate: null };
  }

  if (!/^[0-9]+$/.test(trimmedValue) || trimmedValue.length > YEAR_VALIDATION_CONFIG.INPUT_MAX_LENGTH) {
    return { isValid: false, year: null, momentDate: null };
  }

  const year = parseInt(trimmedValue, 10);
  if (isNaN(year)) {
    return { isValid: false, year: null, momentDate: null };
  }
  if (year < minYear || year > maxYear) {
    return { isValid: false, year: null, momentDate: null };
  }

  const momentDate = moment().day(1).month(0).year(year);

  return { isValid: true, year, momentDate };
}

export function isNumericAndWithinMax(value: string): boolean {
  return /^[0-9]+$/.test(value) && value.length <= YEAR_VALIDATION_CONFIG.INPUT_MAX_LENGTH;
}

export function validateYearRange(fromYear: number | null, toYear: number | null): boolean {
  return fromYear === null || toYear === null || fromYear < toYear;
}
